import {
  Box,
  FormControl,
  FormLabel,
  Heading,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import RandomNumberProbability from './NoC/RandomNumberProbability';
import SimpleWalker from './NoC/SimpleWalker';
import MouseWalker from './NoC/MouseWalker';

export const NatureOfCode: React.FC = () => {


  return (
    <>
      <Heading mb={12}>Nature of Code</Heading>
      <Box px={{ md: 24, sm: 10 }} mb="10">
        <VStack>
          <FormControl>
            <FormLabel>Random Number Distribution (stops at 100)</FormLabel>
            <RandomNumberProbability />
          </FormControl>
          <FormControl>
            <FormLabel>Simple Walker</FormLabel>
            <SimpleWalker />
          </FormControl>
          <FormControl>
            <FormLabel>Mouse Walker (follows mouse 50%)</FormLabel>
            <MouseWalker />
          </FormControl>
        </VStack>
      </Box>
    </>
  );
};
